export function filterMainPagePizzas(map) {
  return map.filter((value) => {
    return value.Exposer_En_Page_Principal;
  });
}
